import 'semantic-ui-css/semantic.min.css'
import { React , useEffect, useState } from 'react';
import { useNavigate  } from 'react-router-dom';

import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import EpubItem from './Item';
import FeedItem from './FeedItem'
//import data from './' + process.env.PUBLIC_URL + '/data/epublicaties.json'
import { Container , Segment , Pagination , Grid, Icon , Item} from 'semantic-ui-react';
//const pub = process.env.PUBLIC_URL
import './translations/i18n';
import { useTranslation  } from 'react-i18next';
import useWindowDimensions from './useWindowDimensions'
const pjson = require('../package.json')
const homep = (!!pjson.homepage) ? pjson.homepage : '/'

const  ResultList = ({ data , page }) => {
    const itemsPerPage = 15
    const [ firstItem , setFirstItem ] = useState(0)
    const [ newPage , setNewPage ] = useState(page)
    const navigate = useNavigate()
    useEffect(() => {
      setNewPage(page)
      setFirstItem(( page - 1 ) * itemsPerPage)
    },[data])

    const handlePaginationChange = ( e , { activePage } ) => {
        setNewPage(activePage)
        setFirstItem(( activePage - 1 ) * itemsPerPage)
    }
    
    const {height, width} = useWindowDimensions();
    const [ viewNum , setViewNum ] = useState(3)
    const toggleViewNum = () => {
      localStorage.setItem('layoutView' , viewNum === 3 ? 1 : 3)
      setViewNum(viewNum === 3 ? 1 : 3)
    }

    const getRandomInt = (max) => {
      return Math.floor(Math.random() * max);
    }


    const { t , i18n } = useTranslation();
    return (
    <Container>
        <Segment>
          <Grid columns='equal'>
            <Grid.Row>
              <Grid.Column>{data.length} {t('resultaten')}</Grid.Column>
              <Grid.Column width={1}>
                <Icon 
                  bordered
                  inverted
                  circular
                  color='blue'
                  style={{cursor: 'pointer'}} 
                  name='random' 
                  onClick={() => {
                    let k = getRandomInt(data.length)
                    navigate(homep + 'detail/' + data[k][1].id)
                  }} 
                  title={t('random')}
                />
              </Grid.Column>
              {width > 1150 &&
              <Grid.Column width={1}>
                <Icon 
                  bordered
                  inverted
                  circular
                  color='blue' 
                  style={{cursor: 'pointer'}} 
                  name={viewNum === 3 ? 'list layout' : 'grid layout'} 
                  onClick={() => toggleViewNum()} 
                  title={viewNum === 3 ? t('list') : t('grid') }
                />
              </Grid.Column>
              }
              
            </Grid.Row>
          </Grid>
          
        </Segment>
        <Pagination 
            fluid 
            totalPages={Math.ceil(Object.keys(data).length / itemsPerPage)} 
            onPageChange={handlePaginationChange}
            activePage={newPage}
            />
          <Segment>
            
          {viewNum > 1 &&  width > 1150 &&
                <ResponsiveMasonry
                  columnsCountBreakPoints={{1150 : viewNum }}
                >
                  
              <Masonry
                gutter='1.5rem'
              >
                  {data.slice(firstItem,firstItem + itemsPerPage).map((i,v) => {
                    return <EpubItem item={i[1]} key={v} />
                  })}
                  </Masonry>
              
            </ResponsiveMasonry>
            }
            {viewNum > 1 &&  width < 1150 &&
            <Item.Group divided>
            {
              data.slice(firstItem,firstItem + itemsPerPage).map((i,v) => {
            return <FeedItem item={i[1]}/>
          })
            }
          </Item.Group>
            }
          {
                  viewNum === 1 && width > 1150 && 
                    <Item.Group divided>
                      {
                        data.slice(firstItem,firstItem + itemsPerPage).map((i,v) => {
                      return <FeedItem item={i[1]}/>
                    })
                      }
                    </Item.Group>
                  }
            {
                  viewNum === 1 && 
                    <Item.Group divided>
                      {
                        data.slice(firstItem,firstItem + itemsPerPage).map((i,v) => {
                      return <FeedItem item={i[1]}/>
                    })
                      }
                    </Item.Group>
                  }     
                
              
            </Segment>
    </Container>
  );
}

export default ResultList;